import { ICommonTranslations } from '@/translations/default/common';

const common: Partial<ICommonTranslations> = {
  exhibitors: 'Exposants',
  exhibitor: 'Exposant',
  product_interactions: "Candidatures aux offres d'emploi",
};

export default common;
